import { csvCell, formatDuration } from '@coneno/c-sheet-shared'
import type { ReportFormat, TimeEntry } from '@coneno/c-sheet-shared'

interface ReportLookups {
  personNames: Map<string, string>
  projectNames: Map<string, string>
  projectCustomers: Map<string, string | null>
  customerNames: Map<string, string>
  taskNames: Map<string, string>
}

const columns = [
  'date',
  'person',
  'client',
  'project',
  'task',
  'durationMinutes',
  'duration',
  'description',
  'billable',
  'startTime',
  'endTime'
] as const

export function buildReportExport(
  entries: TimeEntry[],
  lookups: ReportLookups,
  format: ReportFormat
): string {
  const rows = entries.map((entry) => {
    const customerId = lookups.projectCustomers.get(entry.projectId)
    return {
      date: entry.workDate,
      person: lookups.personNames.get(entry.personId) ?? 'Unknown person',
      client: customerId ? (lookups.customerNames.get(customerId) ?? 'Unknown client') : '',
      project: lookups.projectNames.get(entry.projectId) ?? 'Unknown project',
      task: entry.taskId ? (lookups.taskNames.get(entry.taskId) ?? 'Unknown task') : '',
      durationMinutes: entry.durationMinutes,
      duration: formatDuration(entry.durationMinutes),
      description: entry.description ?? '',
      billable: entry.billable,
      startTime: entry.startTime,
      endTime: entry.endTime
    }
  })

  return format === 'json'
    ? JSON.stringify(rows, null, 2)
    : [
        columns.map(csvCell).join(','),
        ...rows.map((row) => columns.map((column) => csvCell(row[column])).join(','))
      ].join('\n')
}
